/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_Mock_5_DetailInputs */

const en_cap_full_mock_5_detail = /** @type {(inputs: Cap_Full_Mock_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-hosted, backups tested`)
};

const lv_cap_full_mock_5_detail = /** @type {(inputs: Cap_Full_Mock_5_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pašu uzturēta, rezerves kopijas pārbaudītas`)
};

/**
* | output |
* | --- |
* | "Self-hosted, backups tested" |
*
* @param {Cap_Full_Mock_5_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_mock_5_detail = /** @type {((inputs?: Cap_Full_Mock_5_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_Mock_5_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_mock_5_detail(inputs)
	return en_cap_full_mock_5_detail(inputs)
});